import { render, staticRenderFns } from "./importData.vue?vue&type=template&id=02d51b8c&scoped=true"
import script from "./importData.vue?vue&type=script&lang=js"
export * from "./importData.vue?vue&type=script&lang=js"
import style0 from "./importData.vue?vue&type=style&index=0&id=02d51b8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d51b8c",
  null
  
)

export default component.exports